import React from 'react';
import TestimonialVideoCards from '../../components/site/TestimonialCardStars/TestimonialVideoCards';

import './TestimonialsVideoCardsV5.scss';

const TestimonialsVideoCardsV5Test = ({ customTestimonials }) => (
  <section className="ia-testimonial-section container">
    <TestimonialVideoCards
      isHome
      isAI={false}
      noVideo={false}
      isDistributor={false}
      customTestimonials={customTestimonials}
      title={
        <span className="testimonials-v5-title">
          + 9 mil clientes já melhoraram sua operação comercial com o Mercos
        </span>
      }
    />
  </section>
);

export default TestimonialsVideoCardsV5Test;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/Testimonials/TestimonialsVideoCardsV5Test.jsx